export default __webpack_public_path__ + "static/media/shivalika.c71db3e9.JPG";